import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  Login,
  Registration,
  Dashboard,
  DealershipManagement,
  Appointments,
  Service,
  AIAdjustments,
  Vehicles,
  Services,
  Customers,
  Analytics,
  UserManagement,
  Settings,
} from '../pages';
import BusinessManagementList from '../pages/BusinessManagement/BusinessManagementList';
import BusinessForm from '../pages/BusinessManagement/BusinessForm';
import PasswordReset from '../pages/PasswordReset/PasswordReset';
import PasswordResetConfirm from '../pages/PasswordResetConfirm/PasswordResetConfirm';
import MyProfile from '../pages/Settings/MyProfile';
import CompanyData from '../pages/Settings/CompanyData';
import GeneralSettings from '../pages/Settings/GeneralSettings';
import Integrations from '../pages/Settings/Integrations';
import NotificationPreferences from '../pages/Settings/NotificationPreferences';
import AuthSecurity from '../pages/Settings/AuthSecurity';
import ActivityLogs from '../pages/Settings/ActivityLogs';
import DataExport from '../pages/Settings/DataExport';
import RetentionPolicies from '../pages/Settings/RetentionPolicies';
import Privacy from '../pages/Settings/Privacy';
import { MainLayout } from '../components';
import PrivateRoute from './PrivateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/registration" element={<Registration />} />
      <Route path="/password-reset" element={<PasswordReset />} />
      <Route path="/password/reset/confirm/:uid/:token" element={<PasswordResetConfirm />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="dealership" element={<DealershipManagement />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="service" element={<Service />} />
        <Route path="ai-adjustments" element={<AIAdjustments />} />
        <Route path="vehicles" element={<Vehicles />} />
        <Route path="services" element={<Services />} />
        <Route path="customers" element={<Customers />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="business-management" element={<BusinessManagementList />} />
        <Route path="business-management/new" element={<BusinessForm />} />
        <Route path="business-management/edit/:id" element={<BusinessForm />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="settings" element={<Settings />}>
          <Route index element={<Navigate to="/settings/my-profile" replace />} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="company-data" element={<CompanyData />} />
          <Route path="general" element={<GeneralSettings />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="notifications" element={<NotificationPreferences />} />
          <Route path="auth-security" element={<AuthSecurity />} />
          <Route path="activity-logs" element={<ActivityLogs />} />
          <Route path="data-export" element={<DataExport />} />
          <Route path="retention" element={<RetentionPolicies />} />
          <Route path="privacy" element={<Privacy />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
